// src/App.js

import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Import your Layout and page components
import Layout from './Layout';
import HomePage from './pages/HomePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SutraPage from './pages/SutraPage'; // 1. Import the SutraPage component
import UpcomingGamesPage from './pages/UpcomingGamesPage'; // Import Upcoming Games Page

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          
          {/* 2. Add the new route for the About page */}
          <Route path="about" element={<AboutPage />} />
          <Route path="sutra" element={<SutraPage />} />
          <Route path="upcoming" element={<UpcomingGamesPage />} />
          <Route path="privacy" element={<PrivacyPolicyPage />} />
          {/* Add other pages here in the future, like /contact */}

          <Route path="contact" element={<ContactPage />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;